export default "__VITE_ASSET__CWaCnPJM__";